/** Возвращает модуль числа */
export const getMathAbs = (num?: number | null) => Math.abs(num ?? 0);
